module.exports = __webpack_public_path__ + "img/container-home-profile.432161d2.webp";